import { Box, Item, Text } from '@factorialco/deprecated-design-system'
import {
  FactorialTeamFragment,
  SettingsStepsLegalEntityFragment,
} from 'generated/resources/graphql'
import { keyBy } from 'lodash'

import { LevelItem } from 'modules/payroll_integrations_datev_lauds/components/SettingsSteps/LevelItem'
import { upsertDepartmentMappings } from 'modules/payroll_integrations_datev_lauds/components/SettingsSteps/Steps/helper'
import { DatevMapping, DatevWizardData } from 'modules/payroll_integrations_datev_lauds/lib/types'

interface DepartmentsByLegalEntityProps {
  data: DatevWizardData
  onMappingChanged: (mappings: DatevMapping[]) => void
  legalEntity: SettingsStepsLegalEntityFragment
  teams: FactorialTeamFragment[]
}

export const DepartmentsByLegalEntity = ({
  legalEntity,
  teams,
  data,
  onMappingChanged,
}: DepartmentsByLegalEntityProps) => {
  const legalEntityName = legalEntity.legalName

  const departmentOptions: Item[] = JSON.parse(
    data.answers[`departments_${legalEntity.id}`] ?? '[]'
  )
  const mappings: DatevMapping[] = data.sources?.departments?.mappings ?? []
  const legalEntityId = legalEntity.id.toString()
  const mappingsById = keyBy(
    mappings.filter((mapping) => mapping?.meta?.legal_entity_id === legalEntityId),
    'factorial_id'
  )

  const findSelection = (departmentId: string) => {
    const mapping = mappingsById[departmentId]

    if (!mapping) return ''
    return departmentOptions.find((option) => option.value === mapping.datev_id)?.label || ''
  }

  const setFormValues = (value: string, itemId: string) => {
    const newMappings = upsertDepartmentMappings(mappings, value, itemId, legalEntityId)
    onMappingChanged(newMappings)
  }

  return (
    <Box gap="s24">
      {legalEntityName && <Text.Header2>{legalEntityName}</Text.Header2>}

      {teams.map((team) => (
        <LevelItem
          key={team.id.toString()}
          name={team.name}
          selectedValue={findSelection(team.id.toString())}
          options={departmentOptions}
          onSelect={(value, _label) => setFormValues(value, team.id.toString())}
        />
      ))}
    </Box>
  )
}
